import { BrowserRouter, Route, Routes, Switch } from "react-router-dom";
import LandingPage from "./pages/LandingPage";

import "bootstrap/dist/css/bootstrap.min.css";
import Login from "./pages/Login";
import SectionPage from "./pages/Section";
import "./assets/css/style.css";
import { Provider } from "react-redux";
import configureStore from "./store";
import AssessmentPage from "./pages/AssessmentPage";
const initialState = {};
const store = configureStore(initialState);

function App() {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <Switch>
          <Route exact path="/">
            <LandingPage />
          </Route>
          {/* <Route exact path="/login">
            <Login />
          </Route> */}
          <Route exact path="/app">
            <SectionPage />
          </Route>
          <Route exact path={"/assessment"}>
            <AssessmentPage />
          </Route>
          {/* <Route path='/assessment' component={() => {
              window.location.href = 'https://survey.alchemer.com/s3/7165302/GMSDC-MBE-survey';
              return window.;
          }}/> */}
        </Switch>
      </BrowserRouter>
    </Provider>
  );
}

export default App;
